/**
 * api/ticket.api.js — Ticketing System
 */
import client from './client';

// User
export const raiseTicket   = (data)   => client.post('/tickets', data);
export const getMyTickets  = ()       => client.get('/tickets/mine');

// Admin
export const getAllTickets  = (status) => client.get('/tickets', { params: status ? { status } : {} });
export const getTicket      = (id)     => client.get(`/tickets/${id}`);
export const updateTicketStatus = (id, data) => client.put(`/tickets/${id}/status`, data);
